import BaseServiceCrud from './BaseServiceCrud';

export default class GeoService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'geo';
    }

    getCriteria() {}

    calculateCoordinates(streetName, streetNumber, postalCode, city) {
        let query = this.objToQueryString({
            streetName: streetName,
            streetNumber: streetNumber,
            postalCode: postalCode,
            city: city,
        });
        return this.fetch(`${this.domain}/${this.path}/coordinates${query}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
